import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Monitor } from 'react-feather';
import { translate } from '../../../shared/translations';
import TextInput from '../../../shared/components/FormControls/TextInput/TextInput';
import Dialog from '../../../shared/components/Dialog/Dialog';
import { passwordRecoveryAction, setActiveDialogAction } from '../../../actions/actionCreators';
import { Paragraph1, Label } from '../../../shared/theme/styles';

const ForgotPasswordModalContent = ({ inputValue, onInputChange }) => (
    <div id="forgotPasswordModalContent">
        <div className="passwordRecoverSentence text-secondary" style={Paragraph1}>
            {translate('password_recovery_sentence')}
        </div>
        <label style={Label} htmlFor="forgotPassword">
            {translate('email_address')}
        </label>
        <TextInput
            id="forgotPassword"
            value={inputValue}
            onChange={onInputChange}
            className="modalDialogInput"
            style={Paragraph1}
        />
    </div>
);

export const ForgotPasswordModal = ({ show }) => {
    const dispatch = useDispatch();
    const [inputValue, setInputValue] = useState('');

    const onInputChange = ({ target: { value } }) => setInputValue(value);

    const onDialogClose = () => {
        dispatch(setActiveDialogAction(''));
    };

    const onDialogSubmit = () => {
        dispatch(passwordRecoveryAction(inputValue));
        onDialogClose();
    };

    const footerButtons = [
        {
            text: translate('cancel'),
            variant: 'secondary',
            rightFloat: true,
            onButtonClick: onDialogClose,
        },
        {
            text: translate('submit'),
            variant: 'primary',
            rightFloat: true,
            onButtonClick: onDialogSubmit,
        },
    ];

    return (
        <Dialog
            type="action"
            action={{
                content: (<ForgotPasswordModalContent inputValue={inputValue} onInputChange={onInputChange} />),
            }}
            footerButtons={footerButtons}
            size="md"
            centered
            icon={<Monitor className="modalDialogIcon" size={16} />}
            title={translate('username_and_password_recovery')}
            show={show}
            onHide={onDialogClose}
            indentBody
        />
    );
};

export default ForgotPasswordModal;
